module.exports = __webpack_public_path__ + "img/tk_action_qrcode.17b206ce.jpg";